import React, { useEffect, useState } from 'react';
import './wagons.scss';
import ReturnWagon from '../customer/ticketBooking/components/ReturnWagon';
import { useWagonContext } from '../contexts/wagonContext/wagonContext';
import { useBooking } from '../contexts/ticketBookingContext/TicketBookingContext';

const carriages = {
  GRSOne: ['GRS-011-01', 'GRS-012-01', 'GRS-014-01', 'GRS-013-01'],
  GRSTwo: [
    'GRS-011-06',
    'GRS-011-02',
    'GRS-012-02',
    'GRS-012-06',
    'GRS-013-06',
    'GRS-013-02',
    'GRS-014-06',
    'GRS-014-02',
  ],
  GRSThree: ['GRS-011-09', 'GRS-012-09'],
  GRTFour: ['GRT-777'],
};

function Wagons({
  show,
  data,
  chosenSeats,
  setChosenSeats,
  reserveSeat,
  unReserveSeat,
}) {
  const { isDesktop } = useBooking();
  const { floor } = useWagonContext();
  const [wagons, setWagons] = useState([]);

  const putWagon = (wagon) => {
    const value = Object.values(carriages).find((carriage) => carriage.includes(wagon));

    return (
      Object.keys(carriages).find((key) => carriages[key] === value) || wagon
    );
  };

  const putWagons = (carriagesInfo) => {
    const wagonsGroup = [];
    carriagesInfo?.forEach((carriage) => {
      wagonsGroup.push(putWagon(carriage?.carriage_title));
    });
    setWagons(wagonsGroup);
  };

  useEffect(() => {
    if (show) {
      putWagons(data?.carriages);
    }
  }, [data]);

  return (
    <div className={`train ${chosenSeats?.length >= 9 && 'blocked'} ${!isDesktop && floor && `floor-${floor}`}`}>
      {wagons?.map((wagon, index) => (
        <ReturnWagon
            // eslint-disable-next-line react/no-array-index-key
          key={`${wagon}_${index}`}
          data={data}
          index={index}
          chosenSeats={chosenSeats}
          setChosenSeats={setChosenSeats}
          reserveSeat={reserveSeat}
          unReserveSeat={unReserveSeat}
        />
      ))}
    </div>
  );
}

export default Wagons;
